import { render, staticRenderFns } from "./project-follow.vue?vue&type=template&id=095c7fe2&"
import script from "./project-follow.vue?vue&type=script&lang=js&"
export * from "./project-follow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports